<template>
  <div class="addMessageType">
    <!--发送邮件-->
    <el-dialog
      :title="$t('transportDeliveryOrder.sendMessage.sendEmail')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="866px"
    >
      <el-form
        label-width="auto"
        :model="formData"
        :rules="rules"
        ref="formData"
        :label-position="'right'"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="this.$t('transportDeliveryOrder.sendMessage.addressee')">
              <el-input v-model="warehouseName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="recipient"
              :label="this.$t('transportDeliveryOrder.sendMessage.emailAddress')"
            >
              <el-input
                v-model="formData.recipient"
                :placeholder="this.$t('transportDeliveryOrder.sendMessage.emailAddressPlaceholder')"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row> </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="load" @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
        <el-button :loading="load" type="primary" @click="sendEmail">{{
          $t('dialog.send')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import DataBaseAPI from '@/api/dataBase';
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  // import SearchModal from '@/components/SearchModal';
  import formRules from '../rules/rules';
  import { mapState } from 'vuex';

  export default {
    name: 'sendEmail',
    components: {
      // SearchModal,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      return {
        load: false,
        dialogAdd: false,
        rules: formRules.sendEmail,
        warehouseName: '',
        outboundNo: '',
        formData: {
          recipient: '',
        },
        attachmentPath: [],
      };
    },
    methods: {
      openDialog(flag, data) {
        if (this.$refs['formData']) {
          this.$refs['formData'].resetFields();
        }
        this.dialogAdd = flag;
        this.warehouseName = data.outboundStorageName;
        this.formData.recipient = data.storageContactEmail;
        this.outboundNo = data.outboundNo;
        this.getPrint(0);
      },
      //打印功能
      getPrint(val) {
        this.attachmentPathList = [];
        const params = {
          handleClass: 'print',
          moduleCode: 'outbound',
          templateCode: val == '1' ? 'outboundPrintOne' : 'outboundPrintTwo',
        };
        this.$axios.post(DataBaseAPI.GET_FILE, params).then((res) => {
          if (res.data.code === 0) {
            this.uploadPrint(res.data.data[0], 0);
          }
        });
      },
      //打印或下载
      uploadPrint(val) {
        this.attachmentPath = [];
        const params = {
          dataNo: this.$route.query.outboundNo,
          downloadOrPrint: 'print',
          templateUrl: val.attachmentKey,
          templateCode: 'outboundPrintTwo',
          headCompanyName: this.formData.companyName,
        };
        this.$axios.post(API.EXPORT_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            this.attachmentPath.push(res.data.data.pdf);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //发送短信
      sendEmail() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.load = true;
            let attachmentName = [];
            if (this.attachmentPath.length > 0) {
              attachmentName.push(this.attachmentPath[0].split('/').pop());
            } else {
              attachmentName = [];
            }
            let params = {
              outboundNo: this.outboundNo,
              recipient: this.formData.recipient,
              attachmentUrl: this.attachmentPath,
              attachmentName: ['物流出库单提货单.pdf'],
              headCompanyName: this.formData.companyName,
            };
            this.$axios.post(API.SENDEMAIL_TRANSPORTDELIVERYORDER_API, params).then((res) => {
              this.load = false;
              if (0 == res.data.code) {
                this.dialogAdd = false;
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          }
        });
      },
    },
  };
</script>
